export default "__VITE_ASSET__8418cadc__"